import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button, Form, Fade, Container, Col, Row} from 'react-bootstrap';
import {Formik} from 'formik';
import DatePicker, {registerLocale} from 'react-datepicker';
import CommonMetaTag from './common-meta-tag';
import {printReport} from '../actions/partner';
import 'react-datepicker/dist/react-datepicker.css';
import {SLOT_STATES} from '../constants';
import {useTranslation} from 'react-i18next';
import it from 'date-fns/locale/it';
registerLocale('it', it);

const PartnerBookingsReport = ({createReport, ownedFields, ownedServices, profile}) => {
  const {t} = useTranslation();
  const partnerEmail = profile && profile.user ? profile.user.email : '';

  const setValueForField = (f, id) => {
    f('field', id);
    f('service', null);
  };

  const setValueForService = (f, id) => {
    f('field', null);
    f('service', id);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{start: null, end: null, field: ownedFields[0] ? ownedFields[0].id : null, service: null, bookingsType: SLOT_STATES.available, email: null, surname: null}}
      onSubmit={createReport}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        values
      }) => {
        return (
          <Fragment>
            <CommonMetaTag/>
            <Fade in appear className="partner-report-skywork-content">
              <Container fluid>
                <Row className="justify-content-center">
                  <Col xs={12} lg={9} xl={8}>
                    <section className="partner-report-skywork-card">
                    <div className="partner-report-skywork-card-head"><span className="partner-report-skywork-card-icon"><i className="fa fa-calendar"/></span><div><h2>{t('BOOKING_REPORT')}</h2><p>{t('USE_FOLLOWING_FILTERS')}</p></div></div>
                    <div className="partner-report-skywork-note"><i className="fa fa-clock-o"/><span>{t('REPORT_MAX_DAYS')}</span></div>
                    <Form onSubmit={handleSubmit}>
                      <Form.Row>
                        <Col>
                          <Form.Group>
                            <Form.Label>{t('START_DATE')}</Form.Label><br/>
                            <DatePicker
                              locale="it"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              selected={(values.start && new Date(values.start)) || null}
                              onChange={val => setFieldValue('start', val ? new Date(val).toISOString() : null)}/>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label>{t('END_DATE')}</Form.Label><br/>
                            <DatePicker
                              locale="it"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              selected={(values.end && new Date(values.end)) || null}
                              onChange={val => setFieldValue('end', val ? new Date(val.setHours(23, 59, 59)).toISOString() : null)}/>
                          </Form.Group>
                        </Col>
                      </Form.Row>
                      {
                        <div className="partner-report-skywork-options"><h3>{t('FIELD_OR_SERVICE')}</h3>{[...ownedFields, ...ownedServices].map(f => (
                          <Form.Group key={f.id}>
                            <Form.Check required name="field" type="radio" label={f.name} checked={values.field === f.id || values.service === f.id} onChange={() => f.sport ? setValueForField(setFieldValue,f.id) : setValueForService(setFieldValue,f.id)}/>
                          </Form.Group>
                        ))}</div>
                      }
                      <Form.Group>
                        <Form.Label>{t('BOOKINGS_TYPE')}*</Form.Label>
                        <Form.Check required name="bookingsType" type="radio" label={t('BOOKED_SLOT')} checked={values.bookingsType === SLOT_STATES.available} onChange={() => setFieldValue('bookingsType', SLOT_STATES.available)}/>
                        <Form.Check required name="bookingsType" type="radio" label={t('RESERVED_SLOT')} checked={values.bookingsType === SLOT_STATES.reserved} onChange={() => setFieldValue('bookingsType', SLOT_STATES.reserved)}/>
                      </Form.Group>
                      {
                        values.bookingsType === SLOT_STATES.available ?
                          <Fragment>
                            <Form.Group>
                              <div className="d-flex align-items-center justify-content-between">
                                <Form.Label>{t('BOOKING_EMAIL')}</Form.Label>
                                {
                                  partnerEmail ?
                                    <Button
                                      type="button"
                                      size="sm"
                                      variant="outline-primary"
                                      className="partner-report-skywork-inline-action"
                                      onClick={() => setFieldValue('email', partnerEmail)}
                                    >
                                      Usa email partner
                                    </Button> :
                                    null
                                }
                              </div>
                              <Form.Control name="email" type="text" maxLength={255} placeholder={t('BOOKING_EMAIL')} value={values.email || ''} onChange={handleChange}/>
                            </Form.Group>
                            <Form.Group>
                              <Form.Label>{t('BOOKING_SURNAME')}</Form.Label>
                              <Form.Control name="surname" type="text" maxLength={255} placeholder={t('BOOKING_SURNAME')} value={values.surname || ''} onChange={handleChange}/>
                            </Form.Group>
                          </Fragment>
                        : null
                      }
                      <Button type="submit" className="partner-report-skywork-primary"><i className="fa fa-file-excel-o"/> {t('CREATE_REPORT')}</Button>
                        <p className="partner-report-skywork-waiting">{t('REPORT_WAITING')}</p>
                    </Form>
                    </section>
                  </Col>
                </Row>
              </Container>
            </Fade>
          </Fragment>
        );
      }}
    </Formik>
  );
};

PartnerBookingsReport.propTypes = {
  createReport: PropTypes.func.isRequired,
  ownedFields: PropTypes.array.isRequired,
  ownedServices: PropTypes.array.isRequired,
  profile: PropTypes.object
};

PartnerBookingsReport.defaultProps = {
  profile: null
};

const mapStateToProps = ({login: {profile}, partner: {ownedFields, ownedServices}}) => ({
  profile,
  ownedFields,
  ownedServices
});

const mapDispatchToProps = dispatch => ({
  createReport: values => {
    dispatch(printReport(values));
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerBookingsReport));
